import {
    ArrowIcon,
    CardIcon,
    CommentIcon,
    DocumentViewerIcon,
    EmbedIcon,
    EmojiIcon,
    FrameIcon,
    GroupIcon,
    ImageIcon,
    MindMapIcon,
    PresentationIcon,
    ShapeIcon,
    SketchIcon,
    StickerIcon,
    TableIcon,
    TextIcon,
} from "@/icons/entities";

export function getFilterIcon(type: string) {
    switch (type) {
        case "shape":
            return ShapeIcon;
        case "text":
        case "textV2":
            return TextIcon;
        case "image":
            return ImageIcon;
        case "sketch":
            return SketchIcon;
        case "arrow":
            return ArrowIcon;
        case "mindMap":
            return MindMapIcon;
        case "sticker":
            return StickerIcon;
        case "table":
            return TableIcon;
        case "card":
            return CardIcon;
        case "frame":
            return FrameIcon;
        case "presentation":
            return PresentationIcon;
        case "group":
            return GroupIcon;
        case "comment":
            return CommentIcon;
        case "embed":
            return EmbedIcon;
        case "documentViewer":
            return DocumentViewerIcon;
        case "emoji":
            return EmojiIcon;
        default:
            return type;
    }
}
